// clientErrorReporter.js — Iter 3.5D · مُرسِل واحد لأخطاء الواجهة إلى POST /api/client-errors (لا يرمي أبدًا).
import { APP_VERSION } from "./version";

const clip = (v, n) => String(v ?? "").slice(0, n);

export function newErrorCode() {
  return Math.random().toString(36).slice(2, 10).toUpperCase().padEnd(8, "0");
}

function currentRoute() {
  const tab = new URLSearchParams(window.location.search).get("tab");
  return window.location.pathname + (tab ? `?tab=${tab}` : "");
}

function toError(e) {
  if (e instanceof Error) return e;
  if (typeof e === "string") return new Error(e);
  return new Error((e && e.message) || "خطأ غير معروف");
}

export function reportClientError({ error, componentStack = "", kind = "boundary", code = newErrorCode() }) {
  const err = toError(error);
  const body = {
    code, kind,
    message: clip(err.message, 1000),
    stack: clip(err.stack, 8000),
    component_stack: clip(componentStack, 8000),
    route: clip(currentRoute(), 300),
    build: APP_VERSION,
    ts: new Date().toISOString(),
  };
  import("./api").then(({ api }) => api.post("/client-errors", body)).catch(() => {});
  return code;
}

export function installGlobalErrorReporting() {
  if (window.__twClientErrorsInstalled) return;
  window.__twClientErrorsInstalled = true;
  window.addEventListener("error", (e) => reportClientError({ error: e.error || e.message, kind: "onerror" }));
  window.addEventListener("unhandledrejection", (e) => reportClientError({ error: e.reason, kind: "unhandledrejection" }));
}
